module.exports = window.wp.blockEditor;